import { v4 as uuidv4 } from "uuid";

import {
  DATA_DOMAIN_HEADER,
  SUPERBLOCKS_AUTHORIZATION_HEADER,
  SUPERBLOCKS_EMBED_HEADER,
  SUPERBLOCKS_REQUEST_ID_HEADER,
} from "@superblocksteam/shared";

import AuthProvider from "auth/auth0";
import TokenProvider from "auth/token";
import { SUPERBLOCKS_UI_DATA_DOMAIN } from "env";
import { isOnEmbedRoute } from "utils/embed/messages";

export async function getDashboardRequestHeaders(): Promise<Headers> {
  const headers = new Headers({
    "Content-Type": "application/json",
    [SUPERBLOCKS_EMBED_HEADER]: isOnEmbedRoute() ? "true" : "false",
    [DATA_DOMAIN_HEADER]: SUPERBLOCKS_UI_DATA_DOMAIN,
    [SUPERBLOCKS_REQUEST_ID_HEADER]: uuidv4(),
  });
  const token = await AuthProvider.generateToken();
  const authorizationJwt = TokenProvider.getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (token && authorizationJwt)
    headers.set(SUPERBLOCKS_AUTHORIZATION_HEADER, `Bearer ${authorizationJwt}`);
  return headers;
}
